import Vue from 'vue'
import Vuex from 'vuex'

import { appisAmulenCore, setAuthHeaderAmulenCore, setAuthHeaderElearning, setAuthHeaderAmulenApi } from '../utils/axiosInstances'
// appisAmulenApi

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || null,
    userTemp: {},
    userEdit: {}
  },
  getters: {
    loggedIn (state) {
      return state.token !== null
    }
  },
  mutations: {
    retrieveSession (state, token) {
      state.token = token
    },
    destroySession (state) {
      state.token = null
    },
    USER_TEMP: (state, { user }) => {
      state.userTemp = user
    },
    EDIT_USER: (state, { user }) => {
      state.userEdit = user
    }
  },
  actions: {
    destroySession (context) {
      if (context.getters.loggedIn) {
        localStorage.removeItem('token')
        localStorage.removeItem('name')
        localStorage.removeItem('lastname')
        localStorage.removeItem('email')
        localStorage.removeItem('rut')
        localStorage.removeItem('id')
        localStorage.removeItem('clientName')
        localStorage.removeItem('hostname')
        localStorage.removeItem('clientId')
        sessionStorage.removeItem('rtta')
        sessionStorage.removeItem('elearning')
        context.commit('destroySession')
      }
    },
    async retrieveSession (context, credentials) {
      const response = await appisAmulenCore.post('/signin', {
        user: credentials.user,
        password: credentials.password,
        client: credentials.client
      })
      const responseAmulenApi = process.env.VUE_APP_API2_TOKEN
      const token = response.data.token
      const name = response.data.name
      const lastname = response.data.lastname
      const rut = response.data.rut
      const email = response.data.email
      const id = response.data.id
      const tokenAmulenApi = responseAmulenApi
      localStorage.setItem('token', token)
      localStorage.setItem('name', name)
      localStorage.setItem('lastname', lastname)
      localStorage.setItem('rut', rut)
      localStorage.setItem('email', email)
      localStorage.setItem('id', id)
      context.commit('retrieveSession', token)
      setAuthHeaderAmulenCore(token)
      setAuthHeaderElearning(token)
      setAuthHeaderAmulenApi(tokenAmulenApi)
    }
  },
  modules: {
  }
})
